export enum FormType {
  IRB1 = "B1",
  IR21 = "IR21",
  UNKNOWN = "unknown",
  NULL = "null"
}
export const B1_QUESTION_TAG = "generate_B1";
export const IR21_QUESTION_TAG = "generate_IR21";
